<accessibility-skip-links
  [options]="skipLinkOptions">
</accessibility-skip-links>

@if (isRootUser) {
  <super-bar
    >
  </super-bar>
}

<div class="vertical-nav">
  <dashboard [unifiedLoginApiBase]="unifiedLoginApiBaseUrl">
    @if (loading) {
      <loading></loading>
    } @else {
      <router-outlet></router-outlet>
    }
  </dashboard>
  <pwa-install-prompt></pwa-install-prompt>
</div>
